import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/shared/ui/components/card';

/**
 * One headline metric in the dashboard preview's top row: a label, a big value, a one-line hint,
 * and an icon. Presentational only — the value is pre-formatted by the caller (counts as strings,
 * Money via `formatMoney`), so this card stays unaware of how the number was produced.
 */
export function SummaryCard({
  title,
  value,
  hint,
  icon: Icon,
}: {
  title: string;
  value: string;
  hint: string;
  icon: LucideIcon;
}) {
  return (
    <Card className="gap-0 py-5">
      <CardContent className="flex items-start justify-between gap-3 px-5">
        <div className="flex flex-col gap-1">
          <span className="text-muted-foreground text-sm">{title}</span>
          <span className="text-2xl font-semibold">{value}</span>
          <span className="text-muted-foreground text-xs">{hint}</span>
        </div>
        <span className="bg-muted text-muted-foreground flex size-9 shrink-0 items-center justify-center rounded-lg">
          <Icon className="size-5" />
        </span>
      </CardContent>
    </Card>
  );
}
